import React from "react";

// V4 segmented control: a row of selectable pills replacing native <select>.
// One option is always active (pine). Quiet, calm, thumb-friendly.
export default function SegmentedField({ label, value, options, onChange, testid }) {
  return (
    <div data-testid={testid}>
      {label && (
        <p className="text-[11px] font-semibold uppercase tracking-[0.14em] text-[var(--ink4)] mb-1.5">
          {label}
        </p>
      )}
      <div className="flex flex-wrap gap-1.5">
        {options.map((o) => {
          const active = o.value === value;
          return (
            <button
              key={o.value}
              type="button"
              data-testid={testid ? `${testid}-${o.value}` : undefined}
              onClick={() => onChange(o.value)}
              aria-pressed={active}
              className={`rounded-full px-3.5 py-2 text-xs font-semibold border transition-all duration-200 ${
                active
                  ? "bg-[var(--pine)] text-[var(--on-pine)] border-[var(--pine)] shadow-[0_2px_8px_rgba(44,90,77,0.18)]"
                  : "bg-[var(--surface)] text-[var(--ink2)] border-[var(--line)] hover:border-[var(--pine)] active:bg-[var(--surface2)]"
              }`}
            >
              {o.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
